import PropTypes from 'prop-types';
import React from 'react';
import { Drawer, FontIcon } from 'react-toolbox';
import { ThemeProvider } from 'react-css-themr';
import ColoredButton from 'components/ColoredButton';
import styles from './filtersDrawer.scss';
import RTCheckbox from 'styles/checkbox.scss';
import { isArray } from 'lodash';

const DEFAULT_THEME = {
  RTDrawer: styles,
  RTList: styles,
  RTOverlay: styles,
  RTCheckbox,
};

const FiltersDrawer = ({ theme, title, toggle, active, children, reset, className }) =>
  <ThemeProvider theme={{ ...DEFAULT_THEME, ...theme }}>
    <Drawer
      active={active}
      onOverlayClick={toggle}
      className={`${styles.drawer} ${className}`}
    >
      <FontIcon value="close" className={styles.close_icon} onClick={toggle} />
      <ul className={styles.filtersList}>
        <h5 className={styles.header}>Filter {title}</h5>
        {!isArray(children) &&
          <li key={`filter-item-${children.key}`}>{children}</li>
        }

        { // filter because sometimes child is false
          isArray(children) && children.filter(child => child).map(child =>
            <li key={`filter-item-${child.key}`}>{child}</li>,
          )
        }
        {reset && <li>
          <ColoredButton
            className={styles.button}
            label="Reset filter"
            onClick={reset}
            color="red"
          />
        </li>}
      </ul>
    </Drawer>
  </ThemeProvider>;

FiltersDrawer.defaultProps = {
  theme: {},
};

FiltersDrawer.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
  toggle: PropTypes.func.isRequired,
  active: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  reset: PropTypes.func,
  className: PropTypes.string,
};

export default FiltersDrawer;



// WEBPACK FOOTER //
// ./client/app/shared/components/FiltersDrawer/index.jsx